package pl.mothdigital.neuronowi.components.sections.home.contact

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*
import com.varabyte.kobweb.compose.css.AlignItems
import pl.mothdigital.neuronowi.common.resources.StringResources
import pl.mothdigital.neuronowi.common.resources.UrlResources

@Composable
fun ContactSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50)
            .toAttrs()
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .flexWrap(FlexWrap.Wrap)
                .alignItems(AlignItems.Center)
        ) {
            Column(
                modifier = Modifier
                    .flex(1)
                    .minWidth(300.px)
                    .padding(1.cssRem),
                verticalArrangement = Arrangement.spacedBy((0.8).cssRem),
            ) {
                AppH2 { Text(StringResources.CONTACT_SECTION_TITLE.fixPolishOrphans()) }

                ContactItem(icon = { FaMapLocation() }, text = StringResources.CONTACT_SECTION_ADDRESS)
                ContactItem(icon = { FaEnvelope() }, text = StringResources.CONTACT_SECTION_EMAIL)
                ContactItem(icon = { FaSquarePhone() }, text = StringResources.CONTACT_SECTION_PHONE_1)
                ContactItem(icon = { FaSquarePhone() }, text = StringResources.CONTACT_SECTION_PHONE_2)
            }
            Column(
                modifier = Modifier
                    .flex(1)
                    .minWidth(300.px)
                    .padding(1.cssRem)
            ) {
                Iframe(
                    attrs = {
                        attr("src", UrlResources.GOOGLE_MAPS_IFRAME_URL)
                        attr("width", "100%")
                        attr("height", "300")
                        attr("style", "border:0; border-radius: 12px;")
                        attr("allowfullscreen", "")
                        attr("loading", "lazy")
                        attr("referrerpolicy", "no-referrer-when-downgrade")
                    }
                )
            }
        }
    }
}

@Composable
private fun ContactItem(icon: @Composable () -> Unit, text: String) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        icon()
        HorizontalSpacer((0.8).cssRem)
        SpanText(
            text = text,
            modifier = NoWrapTextStyle.toModifier()
                .fontWeight(FontWeight.Normal)
                .fontSize(0.9.cssRem)
                .color(SiteTheme.green._900)
        )
    }
}
